import type { CommonContextStore } from 'src/types/context'

const USERTYPE_PATIENT = 1

/**
 * Кнопка «Оставить отзыв» доступна анониму, пациенту и staff.
 *
 * Учётка клиники или врача без `patient_profile` кнопку не видит.
 */
export default function canLeaveReview(
  context: CommonContextStore['context'],
  isClosed: boolean,
): boolean {
  if (isClosed) {
    return false
  }

  const { user, feature_flags: featureFlags } = context.request

  if (!user.is_authenticated || user.is_staff) {
    return true
  }

  return featureFlags.td_remove_user2_patient_usage_part_2
    ? Boolean(user.patient_profile)
    : user.user2?.usertype === USERTYPE_PATIENT
}
